import { CloseCircleOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, DatePicker, Flex, Input } from 'antd';
import dayjs from 'dayjs';

import { DATE_PICKER_FORMAT } from '@app/constants';

import { PF } from '@pages/NeuralNetworkLogs/data';
import type { FiltersNeuralNetworkLogsType } from '@pages/NeuralNetworkLogs/types';

const { RangePicker } = DatePicker;
const FILTERS = `${PF}_filters`;

export const Filters: FiltersNeuralNetworkLogsType = ({
  values: { Search, DateE, DateS },
  onFilterChange,
  onSearch,
  onReset,
  disabled,
}) => (
  <Flex className={FILTERS} align="center" wrap="wrap" gap={12}>
    <RangePicker
      value={[DateS ? dayjs(DateS) : null, DateE ? dayjs(DateE) : null]}
      onChange={(dates) => {
        onFilterChange('DateS', dates?.[0]?.format('YYYY-MM-DD'));
        onFilterChange('DateE', dates?.[1]?.format('YYYY-MM-DD'));
      }}
      className={`${PF}_filters_date`}
      placeholder={['Дата с', 'Дата по']}
      disabled={disabled}
      format={DATE_PICKER_FORMAT}
    />
    <Input
      addonBefore={<SearchOutlined />}
      placeholder="Введите ID лога, агента, сущности"
      value={Search}
      onChange={({ target: { value } }) => onFilterChange('Search', value)}
      className={`${FILTERS}_search`}
    />
    <div className={`${PF}_filters_buttons`}>
      <Button
        htmlType="reset"
        onClick={onReset}
        className={`${PF}_filters_buttons_item`}
      >
        <CloseCircleOutlined />
        Сброс
      </Button>
      <Button
        type="primary"
        onClick={onSearch}
        className={`${PF}_filters_buttons_item`}
      >
        Показать
      </Button>
    </div>
  </Flex>
);
